export enum EquipmentAttentionStatus {
  GOOD = 'GOOD',
  MAINTENANCE_DUE = 'MAINTENANCE_DUE',
  MACHINE_FAULT = 'MACHINE_FAULT',
  MACHINE_FAULT_AND_MAINTENANCE_DUE = 'MACHINE_FAULT_AND_MAINTENANCE_DUE',
}
